var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ComponentErrorBoundary } from '@office-start/error-boundary';
import React from 'react';
import { LazyFeature } from './LazyFeature';
/**
 * Shared component error boundary
 * @param options for componentName and disabled
 * @returns a common error boundary for components
 *
 * @todo: Pass in props to support ErrorBoundaryProps and custom fallbacks
 */
export var LazyComponentErrorBoundary = function (_a) {
    var children = _a.children, componentName = _a.componentName, _b = _a.lazyFeatureProps, lazyFeatureProps = _b === void 0 ? {} : _b, onError = _a.onError;
    var combinedProps = __assign(__assign({}, lazyFeatureProps), { componentName: componentName });
    return (React.createElement(ComponentErrorBoundary, { componentName: componentName, onError: onError },
        React.createElement(LazyFeature, __assign({}, combinedProps), children)));
};
//# sourceMappingURL=LazyComponentErrorBoundary.js.map